import { render, staticRenderFns } from "./purchaseOrderDetail.vue?vue&type=template&id=49464c8b&scoped=true"
import script from "./purchaseOrderDetail.vue?vue&type=script&lang=ts"
export * from "./purchaseOrderDetail.vue?vue&type=script&lang=ts"
import style0 from "./purchaseOrderDetail.vue?vue&type=style&index=0&id=49464c8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49464c8b",
  null
  
)

export default component.exports